<template>
    <div>
        <!-- <div class="no-display">
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-container fluid>
            <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
                <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
                <v-btn dark text @click="snackbar = false">Close</v-btn>
            </v-snackbar>

            <v-card class="box no-display">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Monthly Paysheet Summary Report</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-row justify="center" dense>
                    <v-col cols="12" sm="3" md="3">
                        <p><b>Salary Month</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="sal_month"
                            :items="sal_month_list" item-text="name" return-object label="Salary Month" outlined />
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <p><b>Employee Type</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="employee_type"
                            :items="employee_type_list" item-text="name" item-value="id" label="Employee Type"
                            outlined />
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <p><b>Designation</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="designation"
                            :items="designation_list" item-text="name" item-value="id" label="Designation" outlined />
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <p><b>Employee Section</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="section" :items="section_list"
                            item-text="name" return-object label="Employee Section" outlined multiple />
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <p><b>Employee</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="employee" :items="employee_list"
                            item-text="name" item-value="id" label="Employee" outlined />
                    </v-col>
                    <!-- </v-row>
                <v-row justify="center" dense> -->
                    <v-col cols="12" sm="3" md="3" class="pt-8">
                        <v-btn class="button" v-if="sal_month && section" @click="
                fetchSalaryRegister();
                loader = true;
              ">
                            Fetch Report
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card>
            <v-card class="box" v-if="emp_salary_reg_detail.length > 0">
                <v-row dense justify="center" class="no-display">
                    <v-col sm="4" md="4">
                        <v-autocomplete clearable rounded outlined dense v-model="search" :items="emp_salary_reg_detail"
                            item-text="emp_section" label="Search Section" persistent-hint single-line></v-autocomplete>
                    </v-col>
                </v-row>
                <!-- excel btn code -->
                <v-row dense class="no-display">
                    <v-col cols="12" sm="6" md="6">
                        <v-btn rounded color="success" outlined @click="
                fnExcelReport('my-table-id', 'MonthlyPaySheetSummaryReport2')
              ">
                            <v-icon color="success">mdi-export</v-icon>Export
                        </v-btn>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                        <v-btn class="ma-2 no-display" tile outlined color="warning" @click="print"> <v-icon
                                left>mdi-printer</v-icon> Print <v-icon right></v-icon> </v-btn>
                    </v-col>
                </v-row>
                <v-col cols="12" sm="9" md="9" class="no-display">
                    <v-row dense>
                        <v-col cols="12" sm="2" md="2">
                            <v-checkbox v-model="designation_show" label="Designation"></v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="2" md="2">
                            <v-checkbox v-model="purpose" label="Date of joining"></v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="2" md="2">
                            <v-checkbox v-model="section_show" label="Section"></v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="2" md="2">
                            <v-checkbox v-model="acno" label="Bank A/C No."></v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="2" md="2">
                            <v-checkbox v-model="pfac" label="PF A/C"></v-checkbox>
                        </v-col>
                    </v-row>
                </v-col>
                <div id="my-table-id">
                    <!-- header code -->
                    <v-simple-table></v-simple-table>
                    <!-- header end -->
                    <table style="width:100%; border-collapse: collapse; text-align:center; margin-bottom:10px;">
                        <tr class="first-row" style="height: 100px; line-height: 100%;">
                            <td style="padding-top: 30px !important; padding-bottom: 20px; text-align:center;"
                                :colspan="comp_header_earn.length + comp_header_dedu.length + 12">

                                <h2 style="margin:0 0 6px 0; font-size:18px; font-weight:600;">
                                    {{ org_basic_data.trust_name }}
                                </h2>

                                <h1 style="margin:6px 0 6px 0; font-size:20px; font-weight:700;">
                                    {{ org_basic_data.school_name }}
                                </h1>

                                <h3 style="margin:6px 0 0 0; font-size:14px; font-weight:600;">
                                    SALARY FOR {{ sal_month.name }}
                                    <span v-if="search == null">{{ section.name }}</span>
                                    <span v-else>{{ search }}</span>
                                </h3>

                            </td>
                        </tr>
                    </table>
                    <v-simple-table fixed-header dense class="elevation-1 payroll-table">
                        <thead class="last-row">
                            <!-- <tr class="first-row" style="height: 100px; line-height: 100%;">
                                <td style="padding-top: 30px !important; padding-bottom: 20px;" class="text-center"
                                    :colspan="comp_header_earn.length + comp_header_dedu.length + 12">
                                    <h1>{{ org_basic_data.trust_name }}</h1>
                                    <br>
                                    <h2>{{ org_basic_data.school_name }}</h2> <br>
                                    <h3>SALARY FOR {{ sal_month.name }} <span v-if="search == null">{{ section.name
                                            }}</span> <span v-else>{{ search }}</span></h3>
                                </td>
                            </tr> -->
                            <tr>
                                <td class="text-center">Sr.No.</td>
                                <td class="text-center">Name</td>
                                <td class="text-center" v-if="designation_show">Designation</td>
                                <td class="text-center" v-if="purpose">Date of joining</td>
                                <td class="text-center" v-if="section_show">Section</td>
                                <td class="text-center" v-if="acno">Bank A/C No.</td>
                                <td class="text-center" v-if="pfac">PF A/C</td>
                                <td class="text-center">No.Of Day's</td>
                                <td class="text-center" v-for="(earnheader, i) in comp_header_earn" :key="i">
                                    {{ earnheader }}
                                </td>
                                <td class="text-center">Gross Salary</td>
                                <td class="text-center" v-for="(deduheader, k) in comp_header_dedu" :key="k">
                                    {{ deduheader }}
                                </td>
                                <td class="text-center">Tot Deduction</td>
                                <td class="text-center">Net Salary</td>
                                <td>Stamp & Sig.</td>
                            </tr>
                        </thead>
                        <tbody v-for="(s, index) in filteredSortSearchList" :key="index">
                            <tr>
                                <td>{{ index + 1 }}</td>
                                <td>
                                    {{ s.emp_name }}
                                </td>
                                <td v-if="designation_show">{{ s.emp_designation }}</td>
                                <td v-if="purpose">{{ s.date_of_joining }}</td>
                                <td v-if="section_show">
                                    {{ s.emp_section }}
                                </td>
                                <td v-if="acno">
                                    {{ s.emp_bank_ac_no }}
                                </td>
                                <td v-if="pfac">
                                    {{ s.emp_pf_no }}
                                </td>
                                <td>
                                    {{ s.emp_working_days }}
                                </td>
                                <td class="text-center" v-for="(earnvalue, i) in s.comp_value_earn" :key="i">
                                    {{ earnvalue.s_value }}
                                </td>
                                <td>
                                    {{ s.gross_salary }}
                                </td>

                                <td class="text-center" v-for="(deduvalue, k) in s.comp_value_dedu" :key="k">
                                    {{ deduvalue.s_value }}
                                </td>
                                <td>
                                    {{ s.gross_deductions }}
                                </td>
                                <td>
                                    {{ s.net_salary }}
                                </td>
                                <td></td>
                            </tr>
                        </tbody>
                        <tr class="last-row">
                            <td colspan="2">
                                <center><strong>Total Employee :</strong> {{ total_emp }}</center>
                            </td>
                            <td v-if="designation_show"></td>
                            <td v-if="purpose"></td>
                            <td v-if="section_show">

                            </td>
                            <td v-if="acno">

                            </td>
                            <td v-if="pfac">

                            </td>
                            <td>{{ working_days }}</td>
                            <td class="text-center" v-for="(earnvalue, i) in amount_list_final_earn" :key="i">
                                {{ earnvalue }}
                            </td>
                            <td>
                                {{ grosssalary }}
                            </td>
                            <td class="text-center" v-for="(deduvalue, k) in amount_list_final_dedu" :key="k">
                                {{ deduvalue }}
                            </td>
                            <td>
                                {{ grossdeductions }}
                            </td>
                            <td>
                                {{ netsalary }}
                            </td>
                            <td></td>
                        </tr>
                    </v-simple-table>
                </div>
            </v-card>
        </v-container>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
    <!-- /. root div -->
</template>
<script>
    import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
        data: () => ({
            acno: true,
            designation_show: true,
            purpose: true,
            extraBreadcrumbItems: [


            ],
            breadcrumbClass: "breadcrumb-style1",
            section_show: true,
            pfac: true,
            loader: false,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            title: "",
            description: "",
            sal_month_list: [],
            employee_type_list: [],
            employee_list: [],
            designation_list: [],
            sal_month: null,
            sal_month_copy: null,
            inst_list: null,
            employee_type: null,
            employee: null,
            designation: null,
            comp_header_earn: [],
            comp_header_dedu: [],
            emp_salary_reg_detail: [],
            emp_sal_reg_id: null,
            comp_rule_edit: null,
            component_rule_edit: null,
            overlay: false,
            search: null,
            section_list: null,
            section: null,
            amount_list_final_earn: null,
            amount_list_final_dedu: null,
            netsalary: null,
            grosssalary: null,
            grossdeductions: null,
            working_days: null,
            total_emp: null,
            org_basic_data: null,
        }),
        computed: {
            filteredSortSearchList() {
                function compare(a, b) {
                    if (a.name < b.name) return -1;
                    if (a.name > b.name) return 1;
                    return 0;
                }
                if (!this.search) return this.emp_salary_reg_detail.sort(compare);
                return this.emp_salary_reg_detail.filter((tbdata) => {
                    //  alert(tbdata.course_name)
                    return tbdata.emp_section.toLowerCase().indexOf(this.search.toLowerCase()) >= 0;
                });
            },
        },
        methods: {
            print() {
                this.$store.state.drawer = false;
                let that = this;
                window.onafterprint = function () {
                    that.$store.state.drawer = true;
                };
                setTimeout(function () {
                    window.print();
                }, 100);
            },
            fnExcelReport(id, name) {
                var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
                tab_text = tab_text + "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
                tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
                tab_text = tab_text + "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
                tab_text = tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
                tab_text = tab_text + "<table border='1px'>";
                var exportTable = $("#" + id).clone();
                exportTable.find("input").each(function (index, elem) {
                    $(elem).remove();
                });
                tab_text = tab_text + exportTable.html();
                tab_text = tab_text + "</table></body></html>";
                var fileName = name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

                //Save the file
                // var blob = new Blob([tab_text], {
                //     type: "application/vnd.ms-excel;charset=utf-8",
                // });
                // window.saveAs(blob, fileName);
                const blob = new Blob([tab_text], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
       const filename = name+'.xls';

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        // For IE
        window.navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // For modern browsers
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
      }
            },
            editItem(emp_sal_reg_id) {
                //  alert(emp_sal_reg_id)
                this.emp_sal_reg_id = emp_sal_reg_id;
                this.edit_flag = "yes";
                this.dialog_edit = true;
            },
            fetchSalaryRegister() {
                (this.emp_salary_reg_detail = []), (this.comp_header = []);
                const data = {
                    sal_month: this.sal_month.id,
                    employee_type: this.employee_type,
                    designation: this.designation,
                    employee: this.employee,
                    section: this.section,
                };
                this.overlay = true;
                axios
                    .post("/Payroll/fetchMonthlyPaySheetSummaryReport_2_zeal", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.emp_salary_reg_detail = res.data.emp_salary_reg_detail;
                            this.comp_header_earn = res.data.comp_header_earn;
                            this.comp_header_dedu = res.data.comp_header_dedu;
                            this.amount_list_final_earn = res.data.amount_list_final_earn;
                            this.amount_list_final_dedu = res.data.amount_list_final_dedu;
                            this.netsalary = res.data.netsalary;
                            this.grosssalary = res.data.grosssalary;
                            this.working_days = res.data.working_days;
                            this.total_emp = res.data.total_emp;
                            this.grossdeductions = res.data.grossdeductions;
                            this.org_basic_data = res.data.org_basic_data;
                            this.overlay = false;
                            // this.sal_month=''
                        } else if (res.data.flag == "No") {
                            this.showSnackbar("#b71c1c", res.data.snackbar);
                            this.overlay = false;
                            return;
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                            this.overlay = false;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something Went Wrong");
                        this.loader = false;
                    })
                    .finally(() => {
                        this.show_copy_dialog = true;
                    });
            },
            onLoad() {
                axios
                    .post("/Payroll/getInitialData")
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.sal_month_list = res.data.sal_month_list;
                            this.employee_type_list = res.data.employee_type_list;
                            this.employee_list = res.data.instlist;
                            this.designation_list = res.data.designation_list;
                            this.inst_list = res.data.inst_list;
                            this.inst_data = res.data.inst_data;
                            this.section_list = res.data.section_list;
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {});
            },

            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
        },
        mounted() {
            this.onLoad();
        },
        watch: {},
    };
</script>
<style scoped>
thead {
    font-weight: bold !important;
}

th {
    font-weight: bold !important;
}

tr,
td,
th {
    border: 1px solid black;
    /* text-align: center; */
    font-size: small;
}

tr,
tbody {
    border-bottom: 1px solid black;
    border: 1px solid black;
    font-size: small;
}

td {
    font-size: small;
}

@media (min-width: 320px) {

    td,
    th {
        display: table-cell !important;
        font-size: small;
    }

    td+td,
    th+th {
        width: auto;
        font-size: small;
    }
}

v-simple-table {
    white-space: nowrap !important;
    /* text-align: center; */
    font-size: small;
}

.edit-avatar {
    transition: 0.3s;
    border: 1px solid #b0bec5;
}

.edit-avatar:hover {
    background-color: #b0bec5;
}

.edit-v-icon {
    padding-left: 6px;
    font-size: 15px;
}

.edit-v-icon:hover {
    color: white;
}
.last-row{
    font-weight: 800 !important;
}

@media print {

    header,
    footer,
    nav,
    date {
        display: none !important;
    }

    table,
    td,
    tr {
        break-inside: avoid-page;
    }

    /* img {
    width: 100% !important;
  } */
    .scroll {
        overflow-x: hidden;
    }

    body,
    td,
    center {
        font-size: 14pt !important;
    }
    .last-row {
        font-size: 14pt !important;
        /* font-weight: 800 !important; */
    }
    .payroll-table {
        width: 100% !important;
        max-width: 100% !important;
        table-layout: fixed !important;
        overflow-x: hidden !important;
    }
    .first-row{
        line-height: 170% !important;        
    }
    .no-display,
    .v-input__control,
    input[type="button"],
    input[type="submit"],
    input[type="reset"],
    #v-card {
        display: none !important;
    }

    v-card {
        border: none !important;
    }

    .trust-logo {
        width: 86%;
    }

    .schl-logo {
        width: 83%;
    }

    @page {
        /* size: A3 landscape !important; */
        margin: 0;
        /* padding: 0px; */
        /* size: 15.5in 15.5in; */
        size: 34in 23in;
    }


    .box {
        /* height: 100% !important; */
        overflow-x: hidden;
        border: none !important;
    }
}</style>
